
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import RegisteredDevicesList from './RegisteredDevicesList';

interface ManageDevicesCardProps {
  onRegisterNew: () => void;
}

const ManageDevicesCard: React.FC<ManageDevicesCardProps> = ({ onRegisterNew }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Registered Devices</CardTitle>
        <CardDescription>
          View and manage devices registered in your system from all departments: Energy, Gas, and Water.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <RegisteredDevicesList onRegisterNew={onRegisterNew} />
      </CardContent>
    </Card>
  );
};

export default ManageDevicesCard;
